export default function Plot_ChartJS() {
  return (
    <div>
      <h1>Plot_ChartJS Component</h1>
    </div>
  );
}
